/**
 * Converts seconds (BigDecimal, 3dp) to a readable time format HH:mm:ss.sss
 * @param {number|null|undefined} seconds - The time value in seconds
 * @returns {string} Formatted time string or '—' for invalid input
 */
export default function formatMarkerTime(seconds) {
    if (seconds == null || isNaN(seconds)) return '—';

    const totalMs = Math.round(seconds * 1000);
    const hours = Math.floor(totalMs / 3600000);
    const minutes = Math.floor((totalMs % 3600000) / 60000);
    const secs = Math.floor((totalMs % 60000) / 1000);
    const ms = totalMs % 1000;

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}.${String(ms).padStart(3, '0')}`;
}
